


























import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class Status extends Vue {
  @Getter("appMode", { namespace: "app" })
  private appMode!: string;

  @Getter("callback", { namespace: "app" })
  private callback!: string;

  @Getter("token", { namespace: "form" })
  private token!: string;

  private openOPass(): void {
    const url = this.callback.replace(/<<TOKEN>>/gm, this.token);
    window.open(url, "_blank");
  }
}
